import * as React from 'react';
import { RowComponentProps } from 'ui/common/types';
import styles from './log-details.scss';

export const LogDetails: React.FC<RowComponentProps> = props => {

  const {
    componentId,
    className,
    children
  } = props;

    return(
          <div id={componentId} className={`${className} ${styles.logDetailsWrapper}`}>
            <div className={`log-details ${styles.logDetails}`}>
              {children}
            </div>
          </div>
    );
  };
